import { create } from 'zustand';

export type ThemeChoice = 'system' | 'light' | 'dark';

function read(): ThemeChoice {
  try {
    const v = localStorage.getItem('lineage.theme');
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(t: ThemeChoice) {
  if (t === 'system') document.documentElement.removeAttribute('data-theme');
  else document.documentElement.setAttribute('data-theme', t);
}

export const useTheme = create<{ theme: ThemeChoice; set: (t: ThemeChoice) => void }>((set) => ({
  theme: read(),
  set: (t) => {
    try {
      localStorage.setItem('lineage.theme', t);
    } catch {
      /* private mode */
    }
    applyTheme(t);
    set({ theme: t });
  },
}));
